import { makeStyles, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import "@fontsource/ubuntu"
import GridHeader from './GridHeader'
import GridData from "./GridData"
import { useDispatch, useSelector } from 'react-redux'
import { tableData2 } from './../../Redux/invoiceDetails/actions/index';
const useStyles = makeStyles({
    name: {
        color: "white",
        fontSize: "1.5rem",
        fontFamily: "Ubuntu",
        fontWeight: "300"
    },
    main: {
        padding: "0 2rem",
    },
    TableDiv: {
        background: "#273D49CC",
        width: "92vw",
        margin: "2vh 2vw",
        padding: "0.5vw 2vw",
        height: "77vh",
        borderRadius: "0.5rem"
    }
})
const GridPanel = () => {
    const pgSize = useSelector(state => state.pgSize)
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(tableData2(pgSize))
    }, [dispatch, pgSize]);
    const classes = useStyles();
    return (
        <>
            <div className={classes.main}>
                <Typography className={classes.name}>Invoice List</Typography>

            </div>
            <div className={classes.TableDiv}>
                <GridHeader />
                <GridData />
            </div>
        </>
    )
}

export default GridPanel
